import axios from 'axios'

const headerName = import.meta.env.VITE_CLIENT_HEADER_NAME || 'X-Client-Key'
const apiKey = import.meta.env.VITE_CLIENT_API_KEY || ''
const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3333/api/1.0'

const LEGACY_TOKEN_KEYS = ['bera_access_token', 'bera_refresh_token']

export function clearAuthTokens() {
  if (typeof window === 'undefined') return
  for (const key of LEGACY_TOKEN_KEYS) {
    localStorage.removeItem(key)
  }
}

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    [headerName]: apiKey,
  },
})

let isRefreshing = false
let failedQueue: Array<{ resolve: (value?: unknown) => void; reject: (err: any) => void }> = []

function processQueue(error: any) {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve()
    }
  })
  failedQueue = []
}

api.interceptors.request.use((config) => {
  if (headerName && apiKey) {
    config.headers[headerName] = apiKey
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (!originalRequest) return Promise.reject(error)

    const requestUrl = originalRequest.url || ''
    const isAuthEndpoint =
      requestUrl.includes('/auth/login') ||
      requestUrl.includes('/auth/register') ||
      requestUrl.includes('/auth/refresh') ||
      requestUrl.includes('/auth/logout') ||
      requestUrl.includes('/auth/forgot-password') ||
      requestUrl.includes('/auth/reset-password') ||
      requestUrl.includes('/me')

    if (error.response?.status === 401 && !originalRequest._retry && !isAuthEndpoint) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        })
          .then(() => api(originalRequest))
          .catch((err) => Promise.reject(err))
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        await axios.post(
          `${baseURL}/auth/refresh`,
          {},
          {
            withCredentials: true,
            headers: {
              [headerName]: apiKey,
            },
          }
        )
        processQueue(null)
        return api(originalRequest)
      } catch (refreshError) {
        processQueue(refreshError)
        clearAuthTokens()
        console.error('[api] Session refresh failed:', refreshError)
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }
    return Promise.reject(error)
  }
)

export default api
